import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var VehicleService = /** @class */ (function () {
    function VehicleService(http) {
        this.http = http;
    }
    VehicleService.prototype.getByPolicyNumber = function (policyNumber) {
        return this.http.get(environment.server.api.portalpas + "/policy/" + policyNumber + "/vehicle/first");
    };
    VehicleService.prototype.getCarsYearsUntil1990 = function () {
        return this.http.get(environment.server.api.thirdpartyclaim + "/vehicles/years");
    };
    VehicleService.prototype.getCarsYears = function (initialYear) {
        if (initialYear === void 0) { initialYear = 1971; }
        var currentYear = new Date().getFullYear();
        var years = [];
        while (initialYear <= currentYear) {
            years.push(initialYear++);
        }
        return years.map(function (year) {
            return { key: "" + year, value: "" + year };
        }).reverse();
    };
    VehicleService.prototype.getCarVersions = function (makeCode, modelCode, year) {
        return this.http.get(environment.server.api.portalpas + "/CarVersions?makeCode=" + makeCode + "&modelCode=" + modelCode + "&year=" + year)
            .pipe(map(function (response) { return response.carVersions; }));
    };
    VehicleService.prototype.getCarVersionsForSelector = function (makeCode, modelCode, year, modelName) {
        return this.getCarVersions(makeCode, modelCode, year).pipe(map(function (carVersions) { return carVersions.map(function (version) {
            return ({ key: version, value: (modelName && modelName + " ") + version.versionDescription });
        }); }));
    };
    VehicleService.prototype.getDeductibles = function (vehicleId) {
        return this.http.get(environment.server.api.portalpas + "/coverable/" + vehicleId + "/deductibles");
    };
    VehicleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VehicleService_Factory() { return new VehicleService(i0.ɵɵinject(i1.HttpClient)); }, token: VehicleService, providedIn: "root" });
    return VehicleService;
}());
export { VehicleService };
